import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../../config/constants';
import useAsync from '../../../hooks/useAsync';
import { Outlet, useOutletContext } from 'react-router';
// import './data.scss';
import Loading from '../../components/Loading';
import NoData from '../../components/NoData';
import './SumData.scss';
import { useSearchParams } from 'react-router-dom';

function SumData(props) {

    const { userIsNormal, selSumDsId } = useOutletContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const qsDataId = searchParams.get("dataId");
    const [result, setResult] = useState({});

    async function getDataList() {
        const response = await axios.post(`${API_URL}/monitoring-manage/summarizedDatas`, { sumDsId: selSumDsId });
        setResult(response.data);
    }

    const [chkAll, setChkAll] = useState(false);
    const [chkedData, setChkedData] = useState([]);
    const [dataArr, setDataArr] = useState([]);


    useEffect(() => {
        if (selSumDsId > 0) {
            getDataList();
        }
    }, [selSumDsId]);
    // const state = useAsync(getDataList);
    // const { loading, error, data: result } = state;
    // if (loading) return <div className='contentArea' style={{ height: '100%' }}><Loading /></div>
    // if (error) {
    //     console.log(error)
    //     return <div className='contentArea'>페이지를 나타낼 수 없습니다.</div>
    // }
    if (!result) return (<NoData />);
    if (!!!result.sumDsData) return (<Loading />);
    return (
        <Outlet context={{
            sumDsData: result.sumDsData,
            modelTypeArr: result.modelType,
            modelNameArr: result.modelName,
            modelNoArr: result.modelNo,
            modelData: result.modelData,
            chkAll: chkAll,
            setChkAll: setChkAll,
            chkedData: chkedData,
            setChkedData: setChkedData,
            dataArr: dataArr,
            setDataArr: setDataArr,
            startedAt: result.startedAt,
            rowCount: result.rowCount,
            userIsNormal: userIsNormal,
        }} />
    );
}

export default SumData;